<style scoped lang="scss">
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .cons{
    display: none;
  }
  .service_chan{
    margin-bottom: 20px;
    display: flex;
    overflow: auto;
    justify-content: space-around;
    li{
      width: 190px;
      height: 188px;
      //margin-right:100px;
      background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
      background-size: auto!important;
      .img{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      p{
        font-size: 16px;
        color:#4e4e4e;
        margin-bottom: 10px;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
      .liaojie{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        color:#959595;
        cursor: pointer;
      }
    }
    li:hover{
      background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
      background-size: auto!important;
      p{
        color: #fff;
      }
      .liaojie{
        color: #fff;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .required{
    background: none!important;
    margin-left: 0!important;
  }
  .desc{
    font-size: 16px;
  }
  .effect-lists{
    //display: block!important;
    justify-content: space-between;
    flex-wrap:wrap;
    overflow: auto;
  }
  //.effect-lists li{
  //  margin-right: 62px;
  //  float: left;
  //}
  //.effect-lists1 li{
  //  margin-right: 40px!important;
  //  float: left;
  //}
  //.effect-lists li:last-child{
  //  margin-right: 0;
  //}
  .compose-type1{
    padding-bottom: 50px;
    background: url("../../assets/img/产品及服务/基因检测/bg.png") no-repeat;
    background-size: 100% 100%;
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
    .effect-lists1{
      justify-content: flex-start!important;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/基因检测/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/一级标题Banner/基因检测.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
      <p class="desc">从1953年沃森（Watson）、克里克（Crick）共同发现了构成生命结构的基本单位-DNA的双螺旋结构，到2003年人类基因组计划（Human Genome Project, HPG）将人类基因组图谱公布，被认为是人类基因组计划的里程碑，标志着基因组测序时代的到来，随后基因组测序技术突飞猛进式发展，如今Sanger测序、高通量测序等技术的出现让基因组测序更为快速、高效、精准和广泛普及，已经成为遗传学、生物学、医学和药领域的标志性研究工具之一。</p>
      <p class="desc">擎科生物目前已建立Sanger测序平台、结合高通量测序技术，拥有全新升级的Fast NGS 测序技术，可满足基因组、转录组等多组学测序要求，提高基因合成的检测通量，缩短检测时间，加速合成基因组学研究。为人类疾病研究、动植物及微生物的遗传育种、生长发育、群体进化等提供技术支持及解决方案。</p>
      </div>
        <div class="container">
          <div class="c-title">基因检测服务<small>Genetic testing services</small></div>
          <div class="container con">
            <ul class="effect-lists1 effect-lists">
              <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
                <img :src="`/static/img/Gene_${item.img}${currentService===index ? '' : ''}.png`">
                <p style="margin-top: 10px;">{{item.name}}</p>
              </li>
            </ul>
          </div>
          <div class="cons" style="margin-top: 20px;">
            <ul class="effect-lists1 effect-lists">
              <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)">
                <img :src="`/static/img/Gene_${item.img}${currentService===index ? '' : ''}.png`" style="width: 60px;">
                <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
              </li>
            </ul>
          </div>
        </div>

      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/基因检测/bg1.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.完善的科研平台设备和先进技术，专业的生物信息分析团队，测序项目经验丰富，严格的质控标准，高质量服务保证，满足多种科研需求；</p>
                <p class="mb20">2.结合了Sanger测序的高准确性和二代测序的高通量、低成本等优势、优化实验流程，周期短，按时交付高质量数据；</p>
                <p class="mb20">3.强大的服务网络体系，全国近20个本地化实验室，可及时收取客户样品，快速交付测序结果；</p>
                <p class="mb20">4.已于天津建立全国大数据客服中心，全天候24h提供优质的售前售后服务。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务与试剂<small>Related services and Reagents</small></div>
        <div class="con">
          <ul class="effect-lists service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/fenzi1_${item.img}${currentType===index ? '' : '_active'}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class=" service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <div class="gene_img2"><img :src="`/static/img/fenzi1_${item.img}${currentType===index ? '' : '_active'}.png`" style="width: 50px;height: 55px;"></div>
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
      </div>
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'Sanger测序服务', img: '1', ref: '/sanger'},
        {name: '基因组测序服务', img: '2', ref: '/products/Genome_sequencing'},
        {name: '微生物测序服务', img: '3', ref: '/products/Microbial_sequencing'},
        {name: '转录组测序服务', img: '4', ref: '/products/Transcriptome_sequencing'},
        {name: 'Fast NGS', img: '5', ref: '/tec/1.5_generation_sequencing'},
        ],
      gene1: [
        {name: '引物合成',img: '1', ref: '/tec/compose'},
        {name: '基因合成', img: '2',ref: '/tec/gen_compose'},
        {name: '基因功能',img: '4', ref: '/products/Gene_regulation'},
        {name: '病毒包装',img: '5', ref: '/Virus/Virus_packaging'},
        {name: '常规分子项目' ,img: '7',ref: '/products/Conventional_molecular_project'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Gene.vue